import { useMutation } from 'react-query';

import { duplicateProject } from 'shared/api/projects/http';

const useMutateDuplicateProject = (options = undefined) => useMutation((id) => duplicateProject(id), options);

export default useMutateDuplicateProject;
